import React, { useRef } from 'react';
import { Provider, useSelector } from 'react-redux';
import Card from '../Card';
import { listingPerPageLimit } from '../../utils/constants';
import Pagination from '../Pagination';
import ListingFilters from '../ListingFilters';
import ErrorBoundary from '../ErrorBoundary';
import LoadingSpinner from '../LoadingSpinner';
import useHolidayListing from './useHolidayListing';

const HolidayListing = ({ holidayStyles = null }) => {
  const ref = useRef(null);

  const {
    waiting,
    holidays,
    travelTypes,
    activeFilters,
    setActiveFilters,
    setSort,
    currentPage,
    setCurrentPage,
  } = useHolidayListing(ref?.current?.parentNode?.dataset?.id, holidayStyles);

  const renderCards = (items) => {
    if (items.length > 0) {
      return items.map((item) => (
        <Card
          payload={item}
          type="holiday"
          key={`card--${item.id}`}
          className={`o-card--holiday ${
            item.travel_type && item.travel_type.slug
              ? `o-card--${item.travel_type.slug}`
              : ''
          }`}
        />
      ));
    } else {
      return (
        <h5 className="c-holiday-finder__no-results">
          No results were found. Please alter you choice, or{' '}
          <a href="">get in touch</a>
        </h5>
      );
    }
  };

  if (waiting) {
    return <LoadingSpinner ref={ref} />;
  } else {
    const numberOfPages = Math.ceil(holidays.length / listingPerPageLimit);

    let outputArray;
    if (holidays.length > 16) {
      let startIndex = listingPerPageLimit * currentPage;
      startIndex = startIndex === Infinity ? 0 : startIndex;
      const endIndex = (currentPage + 1) * listingPerPageLimit;

      outputArray = holidays.slice(startIndex, endIndex);
    } else {
      outputArray = holidays;
    }

    return (
      <Provider store={window.store}>
        <ErrorBoundary>
          <div className="o-wrapper o-wrapper--wide">
            <div
              className={`c-order ${holidayStyles ? 'c-order--taxonomy' : ''}`}
            >
              <ListingFilters
                travelTypes={travelTypes}
                setter={(value) =>
                  setActiveFilters({ ...activeFilters, travelType: value })
                }
                activeFilters={activeFilters}
                holidaysListing
              />

              <div className="c-order__sort">
                <div className="c-order__sort__field">
                  <label htmlFor="sort">Sort by:</label>

                  <select
                    name="sort"
                    id="sort"
                    onChange={({ target: { value } }) => setSort(value)}
                  >
                    <option value="popular">Most Popular</option>
                    <option value="new">New</option>
                    <option value="price_low">Price (low to high)</option>
                    <option value="price_high">Price (high to low)</option>
                    <option value="a-z">A - Z</option>
                    <option value="z-a">Z - A</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </ErrorBoundary>

        <ErrorBoundary>
          <div className="c-cards u-py-2 u-py-4@tablet u-py-6@tablet-wide">
            <div className="o-wrapper o-wrapper--wide c-cards__body">
              {renderCards(outputArray)}
            </div>
          </div>
        </ErrorBoundary>

        <Pagination
          items={holidays}
          numberOfPages={numberOfPages}
          setter={setCurrentPage}
          currentPage={currentPage}
        />
      </Provider>
    );
  }
};

export default HolidayListing;
